module.exports = __webpack_public_path__ + "img/shopDingYue.eac2fc53.png";